import { FetchQueryOptions } from '@tanstack/react-query';
import { useSelector } from 'react-redux';

import { getMasterProperties } from 'api/masterProperty';
import { queryClient } from 'providers/AppQueryClientProvider';
import { isAgentSelector } from 'store/user/selectors';

const defaultQueryOptions: FetchQueryOptions<any> = {
  staleTime: 3_000, // 5 min
};

type IMasterProperty = {
  handle: string;
  id?: number;
  name: string;
  currentStep: string;
  systemWide: boolean;
  shared?: boolean;
  tags?: string[];
};

type MasterPropertyRes = {
  data: IMasterProperty[];
};

function useFetchMasterProperty() {
  const isAgent = useSelector(isAgentSelector);

  const masterPropertyQuery = async (inputValue: string) => {
    const res: MasterPropertyRes = await queryClient.fetchQuery(
      ['masterProperty', inputValue],
      () => getMasterProperties({ search: inputValue, limit: 100 }),
      defaultQueryOptions,
    );

    if (!res.data) return [];

    const handledData = res.data.map((item) => ({
      pageId: item.id,
      id: item.id,
      name: item.name || item.handle,
      optionActionAvailable: item.currentStep === 'page',
      showContentIndicator: isAgent && (item.systemWide || item?.shared),
      shared: item?.shared,
    }));

    return handledData;
  };

  return { masterPropertyQuery };
}

export { useFetchMasterProperty };
